var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23601_18314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9931 4.50745L4.54915 7.9222L7.6954 9.7432L10.4696 6.9682C10.6104 6.82756 10.8012 6.7486 11.0002 6.74867C11.1991 6.74874 11.3899 6.82784 11.5305 6.96857C11.6712 7.1093 11.7501 7.30013 11.75 7.49909C11.75 7.69804 11.6709 7.88881 11.5301 8.02945L8.75515 10.8044L10.5776 13.9499L13.9931 4.50745ZM14.2354 2.82445C15.1316 2.4997 16.0001 3.3682 15.6754 4.26445L11.7139 15.2182C11.3884 16.1167 10.1614 16.2262 9.68215 15.3989L7.2694 11.2304L3.1009 8.8177C2.27365 8.33845 2.38315 7.11145 3.28165 6.78595L14.2354 2.82445Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23601_18314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/send-white.0cf6d9190a3a0fab3497f1d63f028821.svg";
export { ForwardRef as ReactComponent };